export default {
	title: 'Gestión de Tipos de Terminal',
	actions: {
		add: 'Agregar',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar por Lote'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar {count} registro(s) seleccionado(s)?',
		deleteSuccess: 'Operación exitosa',
		selectDeleteWarning: 'Por favor seleccione el registro a eliminar',
		operateSuccess: 'Operación exitosa',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío'
	},
	form: {
		name: 'Nombre del Terminal',
		mode: 'Modo de Comunicación',
		placeholder: {
			name: 'Ingrese el nombre del terminal',
			mode: 'Seleccione el modo de comunicación'
		}
	},
	table: {
		id: 'ID',
		name: 'Nombre del Tipo de Terminal',
		icon: 'Icono',
		mode: 'Modo de Comunicación',
		channels: 'Canales',
                sysEig: 'Valores característicos',
		sysWave: 'Forma de Onda',
		orgId: 'Organización'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	widgetForm: {
		name: 'Nombre',
		icon: 'Icono',
		mode: 'Modo de Comunicación',
		channels: 'Canales',
                characters: 'Código de función del valor característico',
		topic: 'Tema MQTT',
		accelerate: 'Código de Función de Dominio de Tiempo',
                sysEig: 'Valores característicos',
		sysWave: 'Tipo de Forma de Onda',
		orgId: 'Organización (Diagnóstico)',
		gridLayout: 'Diseño de Cuadrícula',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		placeholder: {
			name: 'Ingrese el nombre',
			icon: 'Seleccione el icono',
			mode: 'Seleccione el modo de comunicación',
                        characters: 'Ingrese el código de función del valor característico',
			topic: 'Ingrese el tema MQTT',
			accelerate: 'Ingrese el código de función de dominio de tiempo',
			orgId: 'Organización (Diagnóstico)'
		},
		options: {
			modeLabel: 'Etiqueta 1'
		}
	}
}
